/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Component, ContentChild, Input } from "@angular/core";
import { NzTextareaCountComponent } from "ng-zorro-antd/input";
import { UiInputDirective } from "@webapp/ui/input/input.directive";

@Component({
  selector: "ui-textarea-count",
  templateUrl: "textarea-count.component.html",
})
export class UiTextareaCountComponent extends NzTextareaCountComponent {
  @ContentChild(UiInputDirective, { static: true }) public nzInputDirective!: UiInputDirective;
  @Input("uiMaxCharacterCount") public nzMaxCharacterCount = 0;
  @Input("uiComputeCharacterCount") public uiComputeCharacterCount(v: string): number {
    return super.nzComputeCharacterCount(v);
  }
  @Input("uiFormatter") public uiFormatter(cur: number, max: number): string {
    return super.nzFormatter(cur, max);
  }
}
